import { useMutation } from '@apollo/client';

import { useEffect } from 'react';

import { styled } from 'styled-components';
import { GQL_UPDATE_TRACKING_THEMATIQUE } from '~/gql/tracking-thematique/tracking-thematique';
import useInactivityDetect from '~/helpers/hooks/activity-detect';
import useSoundAudio from '~/helpers/hooks/soundAudio';
import { useTimer } from '~/helpers/hooks/timer';
import useConnectionStore from '~/helpers/store/connection/connection';
import { changeActivityOrder } from '~/pages/components/game/activities-forms/utils';
import { DialogItem } from '~/pages/components/ui/dialog-item';
import { TActivity } from '~/utils/airtable/types/types';
import { renderFullPath } from '~/utils/common/utils';

type IProps = {
  currentActivity: TActivity;
  nextActivity: () => void;
};

function DialogImage({ currentActivity, nextActivity }: IProps) {
  //const { i18n } = useLingui();
  const { currentTrackingThematiqueId, setCurrentTrackings, currentTrackings } =
    useConnectionStore();

  const { time, start, stop, clear } = useTimer();
  const { playSound } = useSoundAudio();

  const [updateTrackingThematique] = useMutation(
    GQL_UPDATE_TRACKING_THEMATIQUE
  );

  const isActive = useInactivityDetect({ timeout: 5000 });

  useEffect(() => {
    if (!isActive) {
      stop();
    } else {
      start();
    }
  }, [isActive]);

  useEffect(() => {
    start();
    if (currentTrackingThematiqueId) {
      //  setCurrentActivityOrder(currentActivity.order);
      setCurrentTrackings(
        changeActivityOrder(
          currentTrackingThematiqueId,
          currentActivity.order,
          currentTrackings
        )
      );
    }
  }, [currentActivity]);

  async function handleNext() {
    stop();
    try {
      if (currentTrackingThematiqueId) {
        await updateTrackingThematique({
          variables: { id: currentTrackingThematiqueId, time: time },
        });
      }
    } finally {
      clear();
      playSound('click');
      nextActivity();
    }
  }

  return (
    <Container
      $background={renderFullPath(currentActivity.background)}
      onClick={handleNext}
    >
      <SDivContent>
        {currentActivity.background && <SDivBlur />}
        <SImg src={renderFullPath(currentActivity.image)} alt="" />
      </SDivContent>

      <DialogItem
        text={currentActivity.text}
        autor={currentActivity.characterName}
        autorImgSrc={currentActivity.characterImg}
      />
    </Container>
  );
}

export default DialogImage;

const Container = styled.div<{ $background?: string }>`
  align-items: center;
  background-image: ${({ $background }) =>
    $background ? `url('${$background}')` : 'none'};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
  position: relative;
  width: 100%;
`;

const SDivBlur = styled.div<{ $withBackground?: boolean }>`
  background-color: #839097a3;
  height: 100%;
  left: 0;
  top: 0;
  position: absolute;
  width: 100%;
`;

const SDivContent = styled.div`
  flex-grow: 1;
  position: relative;
  width: 100%;
`;

const SImg = styled.img`
  left: 0;
  height: 100%;
  object-fit: contain;
  position: absolute;
  top: 0;
  width: 100%;
  user-select: none;
`;
